import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/web/src/app/(authenticated)/dashboard/DashboardClient.tsx");
